/** Videos from public folder – for Films page */

const BASE = process.env.PUBLIC_URL || "";

/** Encode path for URLs (handles spaces, &, parens in filenames) and prepend BASE */
export function videoSrc(path) {
  if (!path || typeof path !== "string") return "";
  const p = path.startsWith("/") ? path : "/" + path;
  const rest = p.slice(1);
  const encoded = encodeURIComponent(rest).replace(/%2F/g, "/");
  return BASE + "/" + encoded;
}


export const FILMS = [
  {
    slug: "ashwini-shrikant",
    title: "Ashwini & Shrikant",
    tagline: "A celebration of love",
    video: "/A&S8.mp4",
    poster: "/Rectangle45.png",
  },
  {
    slug: "nikita-partik",
    title: "Nikita & Partik",
    tagline: "Every moment, forever",
    location: "Surat",
    description:
      "As the sun sets and the stars begin to twinkle, tonight we gather in the spirit of freedom and creativity. With Yashvi Karan leading the way, we embrace the magic of the night, surrounded by bohemian vibes and endless laughter. Here’s to friendship, unforgettable moments, and letting our souls dance under the moonlight.",
    video: "/highlight of N & P.mp4",
    poster: "/d11.png",
  },
  
  {
    slug: "shivangi-bhaumik",
    title: "Shivangi & Bhaumik",
    tagline: "Wedding Highlights 2025",
    location: "Jaipur",
    description:
      "A celebration of love wrapped in tradition and joy. From vibrant rituals to heartfelt vows, Ridhi and Karan’s wedding was a story of elegance, emotion, and timeless memories captured frame by frame.",
    video: "/videos/ridhi-karan-wedding.mp4",
    video: "/SHIVANGI & BHAUMIK _ Wedding Highlights 2025 _ DreamLight Films.mp4",
    poster: "/Rectangle47.png",
  },
];
export const FILMSDASHBOARD = [
  {
    slug: "ashwini-shrikant",
    title: "Ashwini & Shrikant",
    tagline: "A celebration of love",
    video: "/A&S8.mp4",
    poster: "/Rectangle45.png",
  },
  {
    slug: "shivangi-bhaumik",
    title: "Shivangi & Bhaumik",
    tagline: "Wedding Highlights 2025",
    video: "/SHIVANGI & BHAUMIK _ Wedding Highlights 2025 _ DreamLight Films.mp4",
    poster: "/d11.png",
  },
];
